__turbopack_context__.v({
  "enterYourEmail": "text-field1-module-scss-module__xw6eca__enterYourEmail",
  "error": "text-field1-module-scss-module__xw6eca__error",
  "errorText": "text-field1-module-scss-module__xw6eca__errorText",
  "label": "text-field1-module-scss-module__xw6eca__label",
  "row": "text-field1-module-scss-module__xw6eca__row",
  "textField": "text-field1-module-scss-module__xw6eca__textField",
});
